import { combineReducers } from 'redux';

import membershipsReducer from './memberships/membershipsReducer';

const consumerReducer = combineReducers({
  memberships: membershipsReducer,
});

export default consumerReducer;
